<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <div>
      <h3 class="title-header noprint mt-3">
        {{
          $getVisibleNames(
            "mesh.autonomousteachingactivity",
            true,
            "Actividades de Trabajo Autónomo"
          )
        }}
        <AlternativeNameButton
          :table_name="'mesh.autonomousteachingactivity'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_autonomousteachingactivity'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.autonomousteachingactivity',
                  false,
                  'Actividad de Trabajo Autónomo'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="
              () => $bvModal.show(`new-autonomous-teaching-activity-modal`)
            "
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        v-if="autonomous_teaching_activities.length > 0"
        :filterCustom="filterCustom"
        @emitChangeSearchField="changeInputSearch"
        :items="autonomous_teaching_activities"
        :fields="autonomousTeachingActivitiesFields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="'autonomous_teaching_activities'"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            v-can="'mesh.change_autonomousteachingactivity'"
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.autonomousteachingactivity',
                  false,
                  'Actividad de Trabajo Autónomo'
                ),
              })
            "
            :click_button="
              () =>
                $bvModal.show(
                  `edit-autonomous-teaching-activity-modal-${row.item.id}`
                )
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-can="'mesh.delete_autonomousteachingactivity'"
            :click_button="
              () => askForDeleteAutonomousTeachingActivity(row.item.id)
            "
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.autonomousteachingactivity',
                  false,
                  'Actividad de Trabajo Autónomo'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-autonomous-teaching-activity-modal-${row.item.id}`"
            :title="$t('toolbar.autonomousTeachingActivity.editActivity')"
            size="lg"
            hide-footer
          >
            <AutonomousTeachingActivityForm
              :AutonomousTeachingActivity="row.item"
              @updated="slotUpdatedAutonomousTeachingActivity"
              :institution_id="row.item.school"
              :show_title="false"
            ></AutonomousTeachingActivityForm>
          </b-modal>
        </template>
      </GenericBTable>
      <div v-else>
        <br />
        <strong>{{
          $t("reusable.common.noDataFound") +
          " " +
          $getVisibleNames(
            "mesh.autonomousteachingactivity",
            false,
            "Actividad de Trabajo Autónomo"
          )
        }}</strong>
      </div>
    </div>
    <b-modal
      :id="`new-autonomous-teaching-activity-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.autonomousteachingactivity',
            false,
            'Actividad de Trabajo Autónomo'
          ),
        })
      "
      size="lg"
    >
      <AutonomousTeachingActivityForm
        v-if="user"
        @created="slotCreatedAutonomousTeachingActivity"
        :institution_id="user.school"
      ></AutonomousTeachingActivityForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "AutonomousTeachingActivityView",
  components: {
    AutonomousTeachingActivityForm: () =>
      import("./AutonomousTeachingActivityForm.vue"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },

  data() {
    return {
      input_search: "",
      sortBy: "",
      sortDesc: false,
    };
  },

  computed: {
    ...mapGetters({
      user: "getUser",
      autonomous_teaching_activities: names.AUTONOMOUS_TEACHING_ACTIVITIES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.autonomousteachingactivity",
            true,
            "Actividades de Trabajo Autónomo"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions(
        "mesh.add_autonomousteachingactivity"
      );
      if (has_permission) return has_permission;
      else return false;
    },
    autonomousTeachingActivitiesFields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.autonomousteachingactivity",
              true,
              "Actividades de Trabajo Autónomo"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(row.name, this.input_search) ||
        this.$filtered(row.description, this.input_search)
      ) {
        return true;
      } else return false;
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    slotCreatedAutonomousTeachingActivity() {
      this.$bvModal.hide("new-autonomous-teaching-activity-modal");
    },
    slotUpdatedAutonomousTeachingActivity(autonomous_teaching_activity) {
      this.$bvModal.hide(
        `edit-autonomous-teaching-activity-modal-${autonomous_teaching_activity.id}`
      );
    },
    askForDeleteAutonomousTeachingActivity(autonomous_teaching_activity_id) {
      this.$swal({
        title: this.$t(
          "toolbar.autonomousTeachingActivity.deleteActivityConfirmation"
        ),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(
              names.DELETE_AUTONOMOUS_TEACHING_ACTIVITY,
              autonomous_teaching_activity_id
            )
            .then(() => {
              toast(
                this.$t("toolbar.autonomousTeachingActivity.activityDeleted")
              );
            });
        }
      });
    },
  },
  beforeDestroy() {
    this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
    this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
    this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
  },
  mounted() {},
  created() {
    this.sortBy = "-name";
    this.$store.dispatch(names.FETCH_AUTONOMOUS_TEACHING_ACTIVITIES);
    this.$nextTick(() => {
      this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
      this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
        visible_intelligence_options: [7],
        disabled_selected_intelligence_option: true,
      });
      this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
        intelligence_option: 7,
      });
    });
  },
};
</script>

<style scoped>
.title-header {
  padding: 0 2rem;
}
.btn-add {
  margin-left: 0.4rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  width: 255px;
}
</style>